module.exports = __webpack_public_path__ + "img/kasvurahoitus.f8ce284.png";